import React from 'react';
import './PageLayout.css';
import Footer from '../components/Footer';

function FAQ() {
  return (
    <div className="page-layout">
      <header className="page-header">
        <a href="/" className="page-back-link">← Back to Don't Wordle</a>
      </header>
      <main className="page-content">
        <h1>Frequently asked questions</h1>
        <div className="page-body">
          <h2>Why is this game so frustrating?</h2>
          <p>
            Wordle is actually quite hard to <em>lose</em> if you’re making a serious attempt to win. It’s well calibrated: a first-guess win is unlikely, but the clues tend to steer you toward the answer before you run out of rows.
          </p>
          <p>
            Don’t Wordle reverses that goal—you’re still bound by the same clues, but you must never land on the word the puzzle is pushing you toward. That makes the experience much more unforgiving, which is a big part of the frustration (and the fun).
          </p>
          <h2>Does every Wordle word have a valid Don’t Wordle solution?</h2>
          <p>
            Yes. In fact, every answer word has a <em>mind-bogglingly</em> large number of ways you can legally “not Wordle” and still survive—many different sequences of guesses respect all the clues while never submitting the hidden word. The puzzle is hard because it’s easy to slip into a bad path or trap yourself, not because solutions are rare.
          </p>
          <h2>When does the daily puzzle reset?</h2>
          <p>
            Each puzzle is tied to a calendar day in your browser. The game counts days from May 25, 2022 (puzzle #1). When your local date rolls forward, you get the next puzzle.
          </p>

          <h2>Do I need an account?</h2>
          <p>
            No. Don’t Wordle runs entirely in your browser. Progress for the current day is stored in your device’s local storage (so you can refresh without losing your game). We don’t require sign-up or email to play.
          </p>

          <h2>What is Hard Mode?</h2>
          <p>
            In Hard Mode you get fewer undos per game (two instead of five). You can turn it on in Settings before you start a puzzle; it may be locked once a game is in progress.
          </p>

          <h2>What happens if I “Wordle”?</h2>
          <p>
            If you submit the hidden word as your guess, the game ends immediately—even if you still have undos left. The goal is to avoid guessing that word, and so if you do guess it, you lose!
          </p>


          <h2>How do undos work?</h2>
          <p>
            Undos let you take back your last submitted guess when you’re running out of valid words or want to try a different path. Use them carefully as you have a limited number per game.
          </p>

          <h2>Can I get trapped before the game officially ends?</h2>
          <p>
            Yes. The <strong>valid words remaining</strong> counter only counts how many five-letter words fit your clues right now. It does not check whether any sequence of legal guesses can still get you to the end without typing the Wordle word.
          </p>
          <p>
            You might still be mid-puzzle—for example on row 4 with dozens of words left—and already have no winning path left. The game won’t end until you’re eliminated or you Wordle, but you can be “boxed in” anyway.
          </p>

          <h2>Can I see my stats?</h2>
          <p>
            Yes. Open the statistics icon in the header (or use the Stats button after a game ends) to see your streaks and history for games you’ve played on this device.
          </p>

          <h2>How do I share my result?</h2>
          <p>
            After the game ends, use the Share button to copy a text summary (with emoji grids) to your clipboard, then paste it into a message or social post.
          </p>

          <p>
            <a href="/">Play Don’t Wordle</a>
          </p>
        </div>
      </main>
      <div className="page-footer-slot">
        <Footer />
      </div>
    </div>
  );
}

export default FAQ;
